module.exports = __webpack_public_path__ + "static/media/gender.35936f28.svg";